/* eslint-disable @next/next/no-img-element */
import InstantArticle from "views/articles/InstantArticle"
import BestInstagramApps from "views/articles/BestInstagramApps"
import Link from "next/link"
import { AppInterface } from "types/types"
import AppsListItem from "components/AppsListItem"
import AppsList from "components/AppsList"

const AddAppollowToYourHomeScreenEN = ({
  apps,
  otherApps,
}: {
  apps: AppInterface[]
  otherApps: AppInterface[]
}) => {
  const article = BestInstagramApps["ar"]
  return (
    <InstantArticle {...article}>
      <div dir="rtl" style={{ textAlign: "justify" }}>
        <p>
          Instagram عبارة عن منصة ممتازة للشركات لتنمية علامتها التجارية. يمكنك
          استخدامه للصور ومقاطع الفيديو وحتى مقاطع الفيديو الحية. ومع ذلك ، إذا
          كنت ترغب في تحقيق أقصى استفادة من Instagram ، ففي منشور المدونة هذا ،
          قمنا بتجميع قائمة بأفضل تطبيقات وأدوات iOS لـ Instagram التي صادفناها
          حتى الآن.
        </p>

        <h2>VSCO</h2>
        <p>
          VSCO هو تطبيق لتحرير الصور يحتوي على العديد من المرشحات والتأثيرات.
          التطبيق مجاني للتنزيل ، ولكن يمكنك أيضًا الدفع مقابل بعض الميزات
          المتميزة. يمكنك إعداد حسابك في دقائق ، والذي يتضمن إضافة جميع حسابات
          وسائل التواصل الاجتماعي التي تريد استخدامها مع VSCO.
        </p>
        <p>
          واجهة VSCO بسيطة بما يكفي لأي شخص استخدم Instagram من قبل ، لكنها لا
          تزال تقدم الكثير من الخيارات لأولئك الذين يتطلعون إلى الإبداع في صورهم
          على منصات التواصل الاجتماعي مثل Facebook أو Twitter أيضًا!
        </p>
        <p>
          ستجد مجموعة متنوعة من المرشحات المختلفة المضمنة في هذا التطبيق - ستجد
          كل شيء بدءًا من نغمات الأفلام القديمة (مثالية إذا كنت تحاول تحقيق هذا
          الشعور القديم) من خلال الألوان الزاهية مثل الأحمر / الأزرق / الأخضر ؛
          حتى أن هناك بعض تأثيرات الألوان المائية مدرجة في هذا التطبيق بحيث يمكن
          للمستخدمين إنشاء شيء فريد حقًا عند تصوير المناظر الطبيعية داخل منازلهم
          أو وجهات السفر العالمية في الخارج!
        </p>
        <div className="card card-style pt-3 px-3" dir="ltr">
          <AppsListItem {...apps.find((item) => item.trackId === 588013838)} />
        </div>
        <h2>Layout من Instagram</h2>
        <p>
          يعد Layout from Instagram أداة مجانية تتيح لك إنشاء تخطيطات ذات مظهر
          احترافي لصورة ملفك الشخصي على Instagram وصورة الغلاف والقصة. يمكنك
          استخدامه لدمج صور متعددة في صورة مجمعة واحدة أو إنشاء فسيفساء من الصور
          بأحجام مختلفة.
        </p>
        <p>
          يتوفر Layout من Instagram على كل من الهواتف الذكية التي تعمل بنظامي
          iOS و Android بالإضافة إلى أجهزة الكمبيوتر التي تعمل بنظام macOS أو
          Windows 10.
        </p>
        <div className="card card-style pt-3 px-3" dir="ltr">
          <AppsListItem {...apps.find((item) => item.trackId === 967351793)} />
        </div>
        <h2>Canva</h2>
        <p>
          Canva هي أداة تصميم مجانية وسهلة الاستخدام عبر الإنترنت يمكنها مساعدتك
          في إنشاء رسومات لملف تعريف Instagram الخاص بك. يمكنك استخدام Canva
          لإنشاء صور مجمعة وميمات وشعارات والمزيد.
        </p>
        <p>
          لدى Canva المئات من القوالب للاختيار من بينها بحيث يمكنك بسهولة العثور
          على نموذج يناسب موضوع منشورك أو صورتك. يمكنك أيضًا تحميل الصور مباشرة
          من هاتفك أو جهاز الكمبيوتر الخاص بك إذا لم يكن لديك قالب في الاعتبار
          حتى الآن!
        </p>
        <div className="card card-style pt-3 px-3" dir="ltr">
          <AppsListItem {...apps.find((item) => item.trackId === 897446215)} />
        </div>
        <h2>Unfold</h2>
        <p>
          إذا كنت تريد إنشاء قصص Instagram ، فإن تطبيق Unfold هو تطبيق لا بد
          منه. يحتوي على مجموعة واسعة من القوالب وعناصر التصميم التي يمكنك
          استخدامها لإنشاء قصص ذات مظهر احترافي في بضع دقائق فقط.
        </p>
        <div className="card card-style pt-3 px-3" dir="ltr">
          <AppsListItem {...apps.find((item) => item.trackId === 1247275033)} />
        </div>
        <h2>اخرى</h2>
        <p>
          تعرف ايضاً على ما يفضله المستخدمون، اليك بعض التطبيقات التي يستعملها
          مستخدمونا مع انستغرام
        </p>
        <div dir="ltr">
          <AppsList apps={otherApps} title="" />
        </div>

        <div className="card mt-4">
          <div className="card-body">
            <div className="text-center">
              <i className="fa fa-star color-yellow-dark fa-2x mb-3 "></i>
            </div>
            <p className="color-white">
              هل لديك أي تطبيقات أو أدوات مفضلة تستخدمها لتحقيق أقصى استفادة من
              انستغرام؟ يمكنك مشاركة تطبيقاتك المفضلة من خلال{" "}
              <Link href="/submit">
                <span className="text-white text-decoration-underline">
                  صفحة النشر
                </span>
              </Link>
            </p>
          </div>
          <div className="card-overlay bg-highlight opacity-95" />
          <div className="card-overlay dark-mode-tint" />
        </div>
      </div>
    </InstantArticle>
  )
}

export default AddAppollowToYourHomeScreenEN
